import { render } from "./A01PointNotificationPanelThanks.vue?vue&type=template&id=28ea7aeb&scoped=true&ts=true"
import script from "./A01PointNotificationPanelThanks.vue?vue&type=script&lang=ts"
export * from "./A01PointNotificationPanelThanks.vue?vue&type=script&lang=ts"

import "./A01PointNotificationPanelThanks.vue?vue&type=style&index=0&id=28ea7aeb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ea7aeb"]])

export default __exports__